import { VITE_FORGE_URL } from '@constants';
import { trackEconomyAction } from 'analytics';
import CancelRetentionModal from 'components/Account/CancelRetentionModal';
import ColorButton from 'components/Widget/Button/ColorButton';
import { Tier } from 'dragonmouse-shared/interfaces';
import { useState } from 'react';
import * as S from './styles';

interface CurrentPlanCardProps {
	tier: Tier.TIER_1 | Tier.TIER_2;
	renewalDate?: string;
	organizationId?: string;
}

const CurrentPlanCard = ({ tier, renewalDate, organizationId }: CurrentPlanCardProps) => {
	const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
	const tierName = tier === Tier.TIER_1 ? 'Pro' : 'Max';
	const manageUrl = organizationId
		? `${VITE_FORGE_URL}/stripe/org-manage/${organizationId}`
		: `${VITE_FORGE_URL}/stripe/manage`;

	const onManageBillingClick = () => {
		trackEconomyAction('manage_subscription_clicked');
		window.open(manageUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<S.Base>
			<S.Info>
				<S.PlanName>Current Plan: {tierName}</S.PlanName>
				{renewalDate && <S.Renewal>Next billing on {renewalDate}</S.Renewal>}
			</S.Info>
			<S.Actions>
				<S.CancelLink onClick={() => setIsCancelModalOpen(true)}>Cancel subscription</S.CancelLink>
				<ColorButton label="Manage Billing" color="blue" onClick={onManageBillingClick} />
			</S.Actions>
			{isCancelModalOpen && (
				<CancelRetentionModal
					organizationId={organizationId}
					manageUrl={manageUrl}
					onClose={() => setIsCancelModalOpen(false)}
				/>
			)}
		</S.Base>
	);
};

export default CurrentPlanCard;
